import React from 'react';
import './Spinner.css';

function Spinner({ step, min, max, name, title, formData, setFormData, disabled=false }) {
  const value = formData[name];

  const decreaseQuantity = () => {
    if (!disabled && value > min) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value - step,
      }));
    }
  };

  const increaseQuantity = () => {
    if (!disabled && value < max) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value + step,
      }));
    }
  };


  return (
    <div className="spinnerCtr">
      <label htmlFor={name}>{title}</label>
      <div className="mySpinner">
        <button className={`btn btn-outline-secondary decreaseBtn ${disabled ? 'disabled' : ''}`} type="button" onClick={decreaseQuantity}>-</button>
        <input
          type="number"
          className={`form-control align-spinner spinner-input ${disabled ? 'disabled' : ''}`}
          aria-describedby="basic-addon2"
          value={value}
          step={step}
          min={min}
          max={max}
          name={name}
          disabled ={disabled}

          onChange={(e) => {
            const raw = e.target.value;
            const next = raw === '' ? '' : Number(raw); // allow empty string while typing
            setFormData(prev => ({ ...prev, [name]: next === '' ? 0 : next }));
          }}
          
        />
        <button className={`btn btn-outline-secondary increaseBtn ${disabled ? 'disabled' : ''}`} type="button" onClick={increaseQuantity}>+</button>
      </div>
    </div>
  );
}

export default Spinner;
